import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './submitActions.module.scss';
import { Button, Spinner, Alert } from '../../components';

const SubmitActions = ({
  confirm,
  cancel,
  back,
  loading,
  disabled,
  cancelButtonColor,
  className,
  ...rest
}) => (
  <div className={cn(styles.actions, className)}>
    <Alert />
    {loading && <Spinner />}
    <Button color={cancelButtonColor} url={back}>
      {cancel}
    </Button>
    <Button
      color={disabled ? 'outline' : 'primary'}
      type="submit"
      disabled={disabled || loading}
      {...rest}
    >
      {confirm}
    </Button>
  </div>
);

SubmitActions.defaultProps = {
  confirm: 'Išsaugoti',
  cancel: 'Atšaukti',
  cancelButtonColor: 'dim',
  disabled: false,
  className: '',
};

SubmitActions.propTypes = {
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  back: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  cancelButtonColor: PropTypes.oneOf([
    'primary',
    'dim',
    'light',
    'dark',
    'outline',
  ]).isRequired,
};

export default SubmitActions;
